import React, { useState } from 'react';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
    }, 1500);
  };
  return <section id="contact-form" className="py-24 bg-cream relative overflow-hidden" data-id="element-37">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-charcoal hidden lg:block" data-id="element-38"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-39">
        <div className="grid lg:grid-cols-2 gap-16" data-id="element-40">
          {/* Left Content */}
          <div className="py-12 lg:pr-12" data-id="element-41">
            <h2 className="text-sm font-sans font-semibold tracking-[0.2em] text-gold uppercase mb-4" data-id="element-42">
              Start With a Consultation
            </h2>
            <h3 className="text-4xl md:text-5xl font-serif mb-6 text-balance" data-id="element-43">
              Ready to Enter the Dubai Beauty Market?
            </h3>
            <p className="text-charcoal-light text-lg font-light leading-relaxed mb-8" data-id="element-44">
              Before buying or launching a beauty business in Dubai, it is
              important to understand the numbers, risks and opportunities. Book
              a consultation and we will help you evaluate your idea, investment
              budget, business options and next steps.
            </p>

            <div className="space-y-4" data-id="element-45">
              <div className="flex items-center gap-4" data-id="element-46">
                <div className="w-12 h-12 bg-white flex items-center justify-center border border-charcoal/10 rounded-full" data-id="element-47">
                  <span className="font-serif text-xl text-gold" data-id="element-48">1</span>
                </div>
                <p className="font-medium" data-id="element-49">Leave your details</p>
              </div>
              <div className="flex items-center gap-4" data-id="element-50">
                <div className="w-12 h-12 bg-white flex items-center justify-center border border-charcoal/10 rounded-full" data-id="element-51">
                  <span className="font-serif text-xl text-gold" data-id="element-52">2</span>
                </div>
                <p className="font-medium" data-id="element-53">We contact you to discuss goals</p>
              </div>
              <div className="flex items-center gap-4" data-id="element-54">
                <div className="w-12 h-12 bg-white flex items-center justify-center border border-charcoal/10 rounded-full" data-id="element-55">
                  <span className="font-serif text-xl text-gold" data-id="element-56">3</span>
                </div>
                <p className="font-medium" data-id="element-57">Build your strategy</p>
              </div>
            </div>
          </div>

          {/* Right Form */}
          <div className="bg-white p-8 md:p-12 shadow-2xl shadow-charcoal/5 lg:my-8 relative" data-id="element-58">
            {submitted ? <div className="h-full flex flex-col items-center justify-center text-center py-12" data-id="element-59">
                <div className="w-16 h-16 bg-gold/10 text-gold rounded-full flex items-center justify-center mb-6" data-id="element-60">
                  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-61">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-62" />
                  </svg>
                </div>
                <h4 className="text-3xl font-serif mb-4" data-id="element-63">Request Received</h4>
                <p className="text-charcoal-light font-light" data-id="element-64">
                  Thank you for reaching out. Our advisory team will contact you
                  shortly to schedule your consultation.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-65">
                <h4 className="text-2xl font-serif mb-8 border-b border-charcoal/10 pb-4" data-id="element-66">
                  Request a Consultation
                </h4>

                <div className="grid md:grid-cols-2 gap-6" data-id="element-67">
                  <div className="space-y-2" data-id="element-68">
                    <label htmlFor="name" className="text-sm font-medium text-charcoal-light" data-id="element-69">
                      Full Name
                    </label>
                    <input required type="text" id="name" className="w-full border-b border-charcoal/20 py-2 bg-transparent focus:outline-none focus:border-gold transition-colors" placeholder="Jane Doe" data-id="element-70" />
                  </div>
                  <div className="space-y-2" data-id="element-71">
                    <label htmlFor="phone" className="text-sm font-medium text-charcoal-light" data-id="element-72">
                      Phone / WhatsApp
                    </label>
                    <input required type="tel" id="phone" className="w-full border-b border-charcoal/20 py-2 bg-transparent focus:outline-none focus:border-gold transition-colors" placeholder="+971 50 000 0000" data-id="element-73" />
                  </div>
                </div>

                <div className="space-y-2" data-id="element-74">
                  <label htmlFor="email" className="text-sm font-medium text-charcoal-light" data-id="element-75">
                    Email Address
                  </label>
                  <input required type="email" id="email" className="w-full border-b border-charcoal/20 py-2 bg-transparent focus:outline-none focus:border-gold transition-colors" placeholder="jane@example.com" data-id="element-76" />
                </div>

                <div className="space-y-2" data-id="element-77">
                  <label htmlFor="type" className="text-sm font-medium text-charcoal-light" data-id="element-78">
                    What type of business are you interested in?
                  </label>
                  <select required id="type" className="w-full border-b border-charcoal/20 py-2 bg-transparent focus:outline-none focus:border-gold transition-colors text-charcoal" data-id="element-79">
                    <option value="" data-id="element-80">Select an option...</option>
                    <option value="buy_salon" data-id="element-81">
                      Buy an existing salon/clinic
                    </option>
                    <option value="launch_salon" data-id="element-82">
                      Launch a new salon/clinic
                    </option>
                    <option value="spa_wellness" data-id="element-83">Spa & Wellness Center</option>
                    <option value="other" data-id="element-84">Other</option>
                  </select>
                </div>

                <div className="space-y-2" data-id="element-85">
                  <label htmlFor="budget" className="text-sm font-medium text-charcoal-light" data-id="element-86">
                    Investment Budget (AED)
                  </label>
                  <select required id="budget" className="w-full border-b border-charcoal/20 py-2 bg-transparent focus:outline-none focus:border-gold transition-colors text-charcoal" data-id="element-87">
                    <option value="" data-id="element-88">Select an option...</option>
                    <option value="under_500k" data-id="element-89">Under 500,000 AED</option>
                    <option value="500k_1m" data-id="element-90">500,000 - 1,000,000 AED</option>
                    <option value="1m_3m" data-id="element-91">1,000,000 - 3,000,000 AED</option>
                    <option value="over_3m" data-id="element-92">Over 3,000,000 AED</option>
                  </select>
                </div>

                <div className="space-y-2" data-id="element-93">
                  <label htmlFor="message" className="text-sm font-medium text-charcoal-light" data-id="element-94">
                    Message (Optional)
                  </label>
                  <textarea id="message" rows={3} className="w-full border-b border-charcoal/20 py-2 bg-transparent focus:outline-none focus:border-gold transition-colors resize-none" placeholder="Tell us more about your goals..." data-id="element-95"></textarea>
                </div>

                <button type="submit" disabled={isSubmitting} className="w-full bg-charcoal text-white py-4 text-sm font-medium tracking-wide hover:bg-gold transition-colors duration-300 disabled:opacity-70" data-id="element-96">
                  {isSubmitting ? 'Submitting...' : 'Get My Dubai Beauty Business Plan'}
                </button>
              </form>}
          </div>
        </div>
      </div>
    </section>;
}